export const DEFAULT_OFFER_EXPIRY_OFFSET_MINUTES = 60;
export const SESSION_COOKIE_DEFAULT_NAME = "wingseat.sid";
export const CSRF_COOKIE_NAME = "wingseat.csrf";
export const CSRF_HEADER_NAME = "x-csrf-token";
export const INVITATION_TOKEN_TTL_HOURS = 7 * 24;
export const EMAIL_VERIFICATION_TOKEN_TTL_HOURS = 24;
export const PASSWORD_RESET_TOKEN_TTL_HOURS = 2;
//# sourceMappingURL=constants.js.map